import Configuration from "./components/configuration";
import Viewer from "./components/viewer";
import { useState } from "react";

const Reports = () => {
  const [data, setData] = useState<any>(null);
  return (
    <div className={`mt-4`}>
      <div className="flex w-full flex-col gap-4 lg:flex-row">
        <div className="flex-1 lg:max-w-[400px]">
          <Configuration
            onData={(data) => {
              setData(data);
            }}
          />
        </div>
        <div className="flex-1">
          <Viewer data={data} />
        </div>
      </div>
    </div>
  );
};

export default Reports;
